import React from "react";
import DemoSection from "./DemoSection";
import RequestDemoForm from "./RequestDemoForm";
import CoreFeatures from "./CoreFeatures";

function BookADemo() {
  return (
    <div className="container m-auto">
      <div className="flex flex-col md:flex-row gap-6 px-4 md:px-12 py-8">
        <div className="w-full md:w-1/2">
          <DemoSection />
        </div>
        <div className="w-full md:w-1/2">
          <RequestDemoForm />
        </div>
      </div>
      <CoreFeatures />
    
    </div>
  );
}

export default BookADemo;
